import { LeagueGender } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const leagueGenderDictionary = createSimpleDictionary([
    { id: LeagueGender.Men, name: 'dictionaries.gender.men' },
    { id: LeagueGender.Women, name: 'dictionaries.gender.women' },
]);
